import gql from "graphql-tag";

export const MY_TIME_DELETE_REQUEST = gql`
  mutation deleteMyTimeRequest($_id: String!) {
    deleteMyTimeRequest(_id: $_id)
  }
`;
